<lib-file
  [formControl]="this.formControl"
  [formlyAttributes]="this.field"
  [ngClass]="{
    'ng-dirty ng-invalid p-invalid': this.showError
  }">
</lib-file>
